<template>
    <div class="products-list">
      
           <div class="row">
                <div class="col-sm-6 col-md-4 col-lg-4" 
                v-for="(item, index) in products_list"
                :key="index">
                   <card-template :item="item" />
                </div>
           </div>
    </div>
</template>


<script>
import axios from "axios";
import CardTemplate from "../shared/CardTemplate";
import EditProduct from "./actions/EditProduct"
export default {
  name: "productslist",
  props: ["products_list"],
  components: { CardTemplate, EditProduct },
  data() {
    return {
      selectedProduct: Object
    };
  },
  methods: {
    //manadatory function called from cardTemplate while onClick 'edit'
    editProduct(product){
      // this.will pass the product to the editProduct to bind with Product Object
      this.$refs.editProduct.setProduct(product);
    }
  },
  mounted() {}
};
</script>

<style>
.footerIcons {
  font-size: 95%;
}


</style>
